/* eslint-disable array-callback-return */
import { api } from "../../apis";
import { loginTypeConstant } from "../loginType/loginTypeConstant";
import { toast } from "react-toastify";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import isEmpty from "../../validation/isEmpty";
import { CREATED_AS_TYPE, SHIFT_TYPE } from "../constant";
import { AWS_KEYS, myBucket } from "../../apis/api";
// import isEmpty from "../../validation/isEmpty";

const state = [
  "Andaman and Nicobar Island",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal"
];

export const uploadFileToAws = async (file, fileName) => {
  // Robust presence checks (avoid isEmpty for File/Blob)
  const hasValidFile =
    file instanceof Blob || (file && typeof file.size === "number");
  if (!hasValidFile) {
    toastHelper("error", "File not selected");
    return null;
  }

  const totalSizeMB = file.size / Math.pow(1024, 2);

  if (parseFloat(totalSizeMB).toFixed(2) > 2) {
    toastHelper("error", "File size more than 2mb");
    return null;
  }

  const params = {
    Body: file,
    Bucket: AWS_KEYS.s3Bucket,
    Key: !isEmpty(fileName) ? fileName : file.name
  };

  const uploaded = await myBucket.upload(params).promise();
  const { Location, Key } = uploaded;
  return { Location, Key };
};

const checkLoginType = async (loginType) => {
  if (loginType === loginTypeConstant.Employee) {
    const baseUrlNode = api.BaseUrl_Employee.BASE_URL;
    const baseUrlPython = api.BaseUrl_Employee.BASE_URL_PYTHON;
    return {
      baseUrlNode,
      baseUrlPython
    };
  } else {
    const baseUrlNode = api.BaseUrl_Worker.BASE_URL;
    const baseUrlPython = api.BaseUrl_Worker.BASE_URL_PYTHON;
    return {
      baseUrlNode,
      baseUrlPython
    };
  }
};

const renderShift = (inCreatedAs, outCreatedAs) => {
  let createdAs = "";
  if (inCreatedAs === "-" && outCreatedAs === "-") {
    createdAs = CREATED_AS_TYPE.absent;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.absent &&
    outCreatedAs === CREATED_AS_TYPE.absent
  ) {
    createdAs = CREATED_AS_TYPE.absent;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.inTime &&
    outCreatedAs === CREATED_AS_TYPE.fullTime
  ) {
    createdAs = CREATED_AS_TYPE.fullTime;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.inTime &&
    outCreatedAs === CREATED_AS_TYPE.halfTime
  ) {
    createdAs = CREATED_AS_TYPE.halfTime;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.inTime &&
    outCreatedAs === CREATED_AS_TYPE.earlyOut
  ) {
    createdAs = CREATED_AS_TYPE.earlyOut;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.inTime &&
    outCreatedAs === CREATED_AS_TYPE.overTime
  ) {
    createdAs = CREATED_AS_TYPE.overTime;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.lateComing &&
    outCreatedAs === CREATED_AS_TYPE.fullTime
  ) {
    createdAs = CREATED_AS_TYPE.lateComing;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.lateComing &&
    outCreatedAs === CREATED_AS_TYPE.earlyOut
  ) {
    createdAs = CREATED_AS_TYPE.lateComing;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.lateComing &&
    outCreatedAs === CREATED_AS_TYPE.halfTime
  ) {
    createdAs = CREATED_AS_TYPE.halfTime;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.halfTime ||
    inCreatedAs === CREATED_AS_TYPE.halfTime_3Late ||
    inCreatedAs === CREATED_AS_TYPE.oneHourLate ||
    outCreatedAs === CREATED_AS_TYPE.halfTime ||
    outCreatedAs === CREATED_AS_TYPE.halfTime_2EO
  ) {
    createdAs = CREATED_AS_TYPE.halfTime;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.privilegeLeave ||
    outCreatedAs === CREATED_AS_TYPE.privilegeLeave
  ) {
    createdAs = CREATED_AS_TYPE.privilegeLeave;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.paternityLeave ||
    outCreatedAs === CREATED_AS_TYPE.paternityLeave
  ) {
    createdAs = CREATED_AS_TYPE.paternityLeave;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.paidHoliday ||
    outCreatedAs === CREATED_AS_TYPE.paidHoliday
  ) {
    createdAs = CREATED_AS_TYPE.paidHoliday;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.bereavementLeave ||
    outCreatedAs === CREATED_AS_TYPE.bereavementLeave
  ) {
    createdAs = CREATED_AS_TYPE.bereavementLeave;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.compensatoryOff ||
    outCreatedAs === CREATED_AS_TYPE.compensatoryOff
  ) {
    createdAs = CREATED_AS_TYPE.compensatoryOff;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.maternityLeave ||
    outCreatedAs === CREATED_AS_TYPE.maternityLeave
  ) {
    createdAs = CREATED_AS_TYPE.maternityLeave;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.needBasedLeave ||
    outCreatedAs === CREATED_AS_TYPE.needBasedLeave
  ) {
    createdAs = CREATED_AS_TYPE.needBasedLeave;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.optionalHoliday ||
    outCreatedAs === CREATED_AS_TYPE.optionalHoliday
  ) {
    createdAs = CREATED_AS_TYPE.optionalHoliday;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.outDoorDuty ||
    outCreatedAs === CREATED_AS_TYPE.outDoorDuty
  ) {
    createdAs = CREATED_AS_TYPE.outDoorDuty;
  } else if (
    inCreatedAs === CREATED_AS_TYPE.absent &&
    outCreatedAs !== CREATED_AS_TYPE.absent
  ) {
    createdAs = outCreatedAs;
  } else if (
    inCreatedAs !== CREATED_AS_TYPE.absent &&
    outCreatedAs === CREATED_AS_TYPE.absent
  ) {
    createdAs = inCreatedAs;
  } else {
    createdAs = CREATED_AS_TYPE.fullTime;
  }
  return createdAs;
};

const renderLocationFunction = (locations) => {
  if (locations === null) {
    return <option value="Loading...">Loading...</option>;
  } else {
    return locations.map((data, i) => (
      <option key={i} value={data._id}>
        {data.locationName}
      </option>
    ));
  }
};

const renderReportingMangersFunction = (foundManagers) => {
  if (foundManagers === null) {
    return <option value="Fetching...">Fetching...</option>;
  } else if (foundManagers.length === 0) {
    return (
      <option value="Please select Location...">
        Please select Location...
      </option>
    );
  } else {
    return foundManagers.map((data, i) => (
      <option key={i} value={data._id.employerId}>
        {data._id.employer}
      </option>
    ));
  }
};

const renderAccessLocation = (locations) => {
  if (locations === null || locations.length === 0) {
    return <option value="">No access...</option>;
  } else {
    return locations.map((data, i) => (
      <option
        key={i}
        value={data.locationId + " / " + data.moduleType}
      >
        {data.locationName + " / " + data.moduleType}
      </option>
    ));
  }
};

const renderAccessLocation2 = (locations) => {
  if (locations === null) {
    return <option value="">Loading...</option>;
  } else {
    return locations.map((data, i) => (
      <option key={i} value={data.locationId}>
        {data.locationName}
      </option>
    ));
  }
};

const renderState = () => {
  return state.map((data, i) => (
    <option key={i} value={data}>
      {data}
    </option>
  ));
};

const toastHelper = (type, data) => {
  if (type === "success") {
    toast.success(data, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined
    });
  } else {
    toast.error(data, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined
    });
  }
};

const TimeStampIntoHours = (timeStamp) => {
  // Create a new JavaScript Date object based on the timestamp
  // multiplied by 1000 so that the argument is in milliseconds, not seconds.
  if (!isEmpty(timeStamp)) {
    const stringDate = new Date(timeStamp).toUTCString();
    const time = stringDate.substring(-1, stringDate.length - 7);
    return time.slice(17);
  } else {
    return "-";
  }
};

const TimeStampIntoDate = (timeStamp) => {
  // Create a new JavaScript Date object based on the timestamp
  // multiplied by 1000 so that the argument is in milliseconds, not seconds.
  if (
    timeStamp !== null &&
    typeof timeStamp !== "undefined" &&
    timeStamp !== "-"
  ) {
    const stringDate = new Date(timeStamp).toUTCString();

    return stringDate;
  } else {
    return "-";
  }
};

const FilterWorker = (workerName, Filter) => {
  return workerName.filter((filterWorker) => {
    return (
      filterWorker.workerFullName
        .toLowerCase()
        .indexOf(Filter.toLowerCase()) !== -1
    );
  });
};

const filterQuery = (queryTitle, allQueries) => {
  return allQueries.filter((query) => {
    return (
      query.queryTitle
        .toLowerCase()
        .indexOf(queryTitle.toLowerCase()) !== -1
    );
  });
};

// var csv is the CSV file with headers
const csvJSON = (csv) => {
  const lines = csv.split("\n");

  const result = [];

  const headers = lines[0].split(",");

  for (let i = 1; i < lines.length; i++) {
    const obj = {};
    const currentLine = lines[i].split(",");

    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentLine[j];
    }

    result.push(obj);
  }

  // return result; //JavaScript object
  return JSON.stringify(result); // JSON
};

const advancedFilterWorker = (allUser, filterValue, filterBy) => {
  if (filterBy === "workerFullName") {
    return allUser.filter((filterWorker) => {
      return (
        filterWorker.workerFullName
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1
      );
    });
  } else if (filterBy === "workerNameAndId") {
    return allUser.filter((filterWorker) => {
      return (
        filterWorker.workerFirstName
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1 ||
        filterWorker.workerId
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1
      );
    });
  } else if (filterBy === "workerAadharCardNumber") {
    return allUser.filter((filterWorker) => {
      return (
        filterWorker.workerAadharCardNumber
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1
      );
    });
  } else if (filterBy === "workerId") {
    return allUser.filter((filterWorker) => {
      return (
        filterWorker.workerId
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1
      );
    });
  } else if (filterBy === "fullNameAndId") {
    return allUser.filter((filterWorker) => {
      return (
        filterWorker.workerFullName
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1 ||
        filterWorker.workerId
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1
      );
    });
  } else if (filterBy === "ALL") {
    return allUser.filter((filterWorker) => {
      return (
        filterWorker.workerFullName
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1 ||
        filterWorker.workerAadharCardNumber
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1 ||
        filterWorker.workerId
          .toLowerCase()
          .indexOf(filterValue.toLowerCase()) !== -1
      );
    });
  }
};

// sort date for attendance sheet
const sortDateAscendingOrder = (dataToSort) => {
  return dataToSort.dailyPointsArray.sort((data1, data2) => {
    return data1.Date - data2.Date;
  });
};

const sortShiftDateAscendingOrder = (dataToSort) => {
  return dataToSort.shiftListData.sort((data1, data2) => {
    return data1.date - data2.date;
  });
};

const sortDailyAttByDateAscendingOrder = (dataToSort, byTime) => {
  if (byTime === "inTimeAscending") {
    return dataToSort.sort((data1, data2) => {
      return new Date(data1.inTime) - new Date(data2.inTime);
    });
  } else if (byTime === "inTimeDescending") {
    return dataToSort.sort((data1, data2) => {
      return new Date(data2.inTime) - new Date(data1.inTime);
    });
  } else if (byTime === "outTimeAscending") {
    return dataToSort.sort((data1, data2) => {
      return new Date(data1.outTime) - new Date(data2.outTime);
    });
  } else if (byTime === "outTimeDescending") {
    return dataToSort.sort((data1, data2) => {
      return new Date(data2.outTime) - new Date(data1.outTime);
    });
  }
};

// check if date is weekend
const isWeekend = (date1) => {
  const dateArr = date1.split("/");
  const date = dateArr[0];
  const month = dateArr[1];
  const year = dateArr[2];
  const newDate = month + "/" + date + "/" + year;
  const dt = new Date(newDate);
  if (dt.getDay() === 0) {
    return true;
  } else {
    return false;
  }
};

// // check if date is weekend
// const isWeekend = (date1) => {

//   const finalDate = moment(newDate).format("dddd");
//   if (finalDate === "Sunday") {
//     return true;
//   } else {
//     return false;
//   }
// };

// render date of range
const renderDate = (valueObject) => {
  const date = [];
  let startDate = new Date(valueObject.fromDate);
  const endDate = new Date(valueObject.toDate);

  while (
    moment(startDate, "DD/MM/yyyy").valueOf() <=
    moment(endDate, "DD/MM/yyyy").valueOf()
  ) {
    date.push(moment(startDate, "DD/MM/yyyy").format("DD/MM/yyyy"));
    startDate = moment(startDate, "DD/MM/yyyy")
      .add(1, "days")
      .format("DD/MM/yyyy");
  }

  return date;
};

const getBrowserDetails = async () => {
  const module = {
    options: [],
    header: [
      window.navigator.platform,
      window.navigator.userAgent,
      window.navigator.appVersion,
      window.navigator.vendor,
      window.opera
    ],
    dataOs: [
      {
        name: "Windows Phone",
        value: "Windows Phone",
        version: "OS"
      },
      { name: "Windows", value: "Win", version: "NT" },
      { name: "iPhone", value: "iPhone", version: "OS" },
      { name: "iPad", value: "iPad", version: "OS" },
      { name: "Kindle", value: "Silk", version: "Silk" },
      { name: "Android", value: "Android", version: "Android" },
      { name: "PlayBook", value: "PlayBook", version: "OS" },
      { name: "BlackBerry", value: "BlackBerry", version: "/" },
      { name: "Macintosh", value: "Mac", version: "OS X" },
      { name: "Linux", value: "Linux", version: "rv" },
      { name: "Palm", value: "Palm", version: "PalmOS" }
    ],
    dataBrowser: [
      { name: "Chrome", value: "Chrome", version: "Chrome" },
      { name: "Firefox", value: "Firefox", version: "Firefox" },
      { name: "Safari", value: "Safari", version: "Version" },
      { name: "Internet Explorer", value: "MSIE", version: "MSIE" },
      { name: "Opera", value: "Opera", version: "Opera" },
      { name: "BlackBerry", value: "CLDC", version: "CLDC" },
      { name: "Mozilla", value: "Mozilla", version: "Mozilla" }
    ],
    init: function () {
      const agent = this.header.join(" ");
      const os = this.matchItem(agent, this.dataOs);
      const browser = this.matchItem(agent, this.dataBrowser);

      return { os: os, browser: browser };
    },
    matchItem: function (string, data) {
      let i = 0;
      let j = 0;
      let regex;
      let regexVersion;
      let match;
      let matches;
      let version;

      for (i = 0; i < data.length; i += 1) {
        regex = new RegExp(data[i].value, "i");
        match = regex.test(string);
        if (match) {
          regexVersion = new RegExp(
            data[i].version + "[- /:;]([\\d._]+)",
            "i"
          );
          matches = string.match(regexVersion);
          version = "";
          if (matches) {
            if (matches[1]) {
              matches = matches[1];
            }
          }
          if (matches) {
            matches = matches.split(/[._]+/);
            for (j = 0; j < matches.length; j += 1) {
              if (j === 0) {
                version += matches[j] + ".";
              } else {
                version += matches[j];
              }
            }
          } else {
            version = "0";
          }
          return {
            name: data[i].name,
            version: parseFloat(version)
          };
        }
      }
      return { name: "unknown", version: 0 };
    }
  };
  return await module.init();
};

const showAttendanceAs = (points, type) => {
  if (type === "byPoints") {
    if (points === null) {
      return "-";
    } else {
      return points;
    }
  } else if (type === "className") {
    if (points === null || points === "ABSENT") {
      return "badge badge-danger";
    } else if (points === "IN-TIME PUNCHED" || points === "IN-TIME") {
      return "badge badge-info";
    } else if (
      points === "HALF-TIME PUNCHED" ||
      points === "HALF-TIME" ||
      points === "HALF-DAY" ||
      points === "HALF-TIME PUNCHED / LATE" ||
      points === "HALF-TIME PUNCHED / 3 LATE" ||
      points === "HALF-TIME PUNCHED / EARLY-OUT PUNCHED" ||
      points === "WEEKLY-OFF"
    ) {
      return "badge badge-warning";
    } else if (
      points === "FULL-TIME PUNCHED" ||
      points === "FULL-TIME" ||
      points === "FULL-DAY"
    ) {
      return "badge badge-success";
    } else if (
      points === "OVER-TIME PUNCHED" ||
      points === "OVER-TIME"
    ) {
      return "badge badge-primary";
    } else if (
      points === "OUTDOOR DUTY PUNCHED" ||
      points === "OUTDOOR DUTY"
    ) {
      return "badge badge-gray-dark";
    } else if (
      points === "EARLY-OUT PUNCHED" ||
      points === "EARLY-OUT"
    ) {
      return "badge badge-purple";
    } else {
      return "badge badge-dark";
    }
  } else if (type === "byValue") {
    if (points === null) {
      return "AB";
    } else if (Number(points) === 0) {
      return "I.N";
    } else if (Number(points) > 0 && Number(points) <= 0.5) {
      return "H.D";
    } else if (Number(points) > 0.5 && Number(points) <= 1) {
      return "P";
    } else if (Number(points) > 1) {
      return "O.T";
    }
  } else if (type === "string") {
    if (points === null || points === "ABSENT") {
      return "AB";
    } else if (points === "IN-TIME PUNCHED" || points === "IN-TIME") {
      return "I.N";
    } else if (
      points === "HALF-TIME PUNCHED" ||
      points === "HALF-TIME" ||
      points === "HALF-DAY"
    ) {
      return "H.D";
    } else if (points === "HALF-TIME PUNCHED / LATE") {
      return "H.D / LT";
    } else if (points === "HALF-TIME PUNCHED / 3 LATE") {
      return "H.D / 3 LT";
    } else if (points === "HALF-TIME PUNCHED / EARLY-OUT PUNCHED") {
      return "H.D / E.O";
    } else if (
      points === "FULL-TIME PUNCHED" ||
      points === "FULL-TIME" ||
      points === "FULL-DAY"
    ) {
      return "P";
    } else if (
      points === "OVER-TIME PUNCHED" ||
      points === "OVER-TIME"
    ) {
      return "O.T";
    } else if (points === "LEAVE PUNCHED" || points === "LEAVE") {
      return "L";
    } else if (
      points === "OUTDOOR DUTY PUNCHED" ||
      points === "OUTDOOR DUTY"
    ) {
      return "O.D";
    } else if (points === "WEEKLY-OFF") {
      return "W.O";
    } else if (
      points === "EARLY-OUT PUNCHED" ||
      points === "EARLY-OUT"
    ) {
      return "E.O";
    }
  } else {
    if (points === null) {
      return "AB";
    } else if (Number(points) === 0) {
      return "I.N";
    } else if (Number(points) > 0 && Number(points) <= 0.5) {
      return "H.D";
    } else if (Number(points) > 0.5 && Number(points) <= 1) {
      return "P";
    } else if (Number(points) > 1) {
      return "O.T";
    }
  }
};

const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

const locationRender = (currentUser, localStorageOrNot) => {
  let locationArray = [];
  if (localStorageOrNot) {
    locationArray = localStorage.getItem("selectedModule");
  } else {
    locationArray = currentUser.employeeAccess;
  }

  if (!isEmpty(locationArray)) {
    return locationArray;
  } else {
    return [];
  }
};

const uploadImageToCloudinary = async (
  imageFile,
  cloudName,
  cloudinaryApi,
  uploadPreset,
  public_id
) => {
  const formData = new FormData();
  formData.append("file", imageFile);
  formData.append("upload_preset", uploadPreset);
  formData.append("cloud_name", cloudName);
  formData.append("public_id", public_id);
  // formData.append("overwrite", true);

  const res = await fetch(cloudinaryApi, {
    method: "POST",
    body: formData
  });
  const image = await res.json();
  // console.log(image);
  return image.secure_url;
  // const formData = new FormData();
  // formData.append("file", base64);
  // formData.append("upload_preset", uploadPreset);
  // formData.append("cloud_name", cloudName);
  // const xhr = new XMLHttpRequest();
  // await xhr.open("POST", cloudinaryApi);
  // xhr.send(formData);
  // return xhr.responseURL;
};

const uploadMultipleImageToCloudinary = async (
  screenshots,
  cloudName,
  cloudinaryApi,
  uploadPreset
) => {
  const url = [];
  // eslint-disable-next-line no-unreachable-loop
  for (const screenshot of screenshots) {
    const data = new FormData();
    data.append("file", screenshot);
    data.append("upload_preset", uploadPreset);
    data.append("cloud_name", cloudName);

    const res = await fetch(cloudinaryApi, {
      method: "POST",
      body: data
    });
    const image = await res.json();
    url.push(image.secure_url);
  }
  return url;
};

const isSuperAdmin = (loginUser) => {
  if (
    loginUser.workerDepartment === "SUPER ADMIN" &&
    loginUser.workerDesignation === "SUPER ADMIN"
  ) {
    return true;
  } else {
    return false;
  }
};

// is admin
const isAdmin = (loginUser) => {
  if (
    loginUser.workerDepartment === "ADMIN" &&
    loginUser.workerDesignation === "ADMIN"
  ) {
    return true;
  } else {
    return false;
  }
};

const tableSkeleton = (count) => {
  const tableRowArray = [];
  let tableDivision;
  for (let i = 0; i < count; i++) {
    tableDivision = (
      <td key={i}>
        <Skeleton count={10} />
      </td>
    );
    tableRowArray.push(tableDivision);
  }
  return tableRowArray;
};

// const timeToSecond = (time) => {
//   const newTime = !isEmpty(time) ? time : "00:00:00";
//   const splitTime = newTime.split(":");

//   return Number(
//     (Number(splitTime[0] * 60) + Number(splitTime[1])) * 60 +
//       Number(splitTime[2])
//   );
// };
const secondsToTime = (second) => {
  const secondConvertedIntoNumber = Number(second);
  const hours = Math.floor(secondConvertedIntoNumber / 3600);
  const minutes = Math.floor((secondConvertedIntoNumber % 3600) / 60);
  const seconds = Math.floor((secondConvertedIntoNumber % 3600) % 60);
  return hours + ":" + minutes + ":" + seconds;
};

const totalCanteen = (dailyCanteenArray) => {
  let TotalBreakFast = 0;
  let TotalLunch = 0;
  let TotalDinner = 0;

  dailyCanteenArray.map((element) => {
    TotalBreakFast = !isEmpty(element.breakFastTime)
      ? TotalBreakFast + 1
      : TotalBreakFast + 0;
    TotalLunch = !isEmpty(element.lunchTime)
      ? TotalLunch + 1
      : TotalLunch + 0;
    TotalDinner = !isEmpty(element.dinnerTime)
      ? TotalDinner + 1
      : TotalDinner + 0;
  });

  return {
    TotalBreakFast,
    TotalLunch,
    TotalDinner
  };
};

const totalPAH = (dailyPointsArray) => {
  const TotalHours = 0;
  let TotalPresent = 0;
  let TotalAbsent = 0;
  let TotalWeekOf = 0;
  let TotalPl = 0;
  let TotalNbl = 0;
  let TotalPtl = 0;
  let TotalMtl = 0;
  let TotalBl = 0;
  let TotalCo = 0;
  let TotalOh = 0;
  let TotalPh = 0;
  let TotalOd = 0;
  let TotalEo = 0;
  let TotalLc = 0;
  let TotalHd = 0;
  let TotalOT = 0;
  let TotalAml = 0;
  let TotalWop = 0;
  dailyPointsArray.forEach((element) => {
    // TotalHours = TotalHours + timeToSecond(element.duration);
    if (element.createdAs === CREATED_AS_TYPE.weeklyOff) {
      TotalWeekOf = TotalWeekOf + 1;
    } else if (
      element.createdAs === CREATED_AS_TYPE.absent ||
      element.createdAs === null
    ) {
      TotalAbsent = TotalAbsent + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.privilegeLeave) {
      TotalPl = TotalPl + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.needBasedLeave) {
      TotalNbl = TotalNbl + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.paternityLeave) {
      TotalPtl = TotalPtl + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.maternityLeave) {
      TotalMtl = TotalMtl + 1;
    } else if (
      element.createdAs === CREATED_AS_TYPE.bereavementLeave
    ) {
      TotalBl = TotalBl + 1;
    } else if (
      element.createdAs === CREATED_AS_TYPE.compensatoryOff
    ) {
      TotalCo = TotalCo + 1;
    } else if (
      element.createdAs === CREATED_AS_TYPE.optionalHoliday
    ) {
      TotalOh = TotalOh + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.paidHoliday) {
      TotalPh = TotalPh + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.outDoorDuty) {
      TotalOd = TotalOd + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.earlyOut) {
      TotalEo = TotalEo + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.lateComing) {
      TotalLc = TotalLc + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.halfTime) {
      TotalHd = TotalHd + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.overTime) {
      TotalOT = TotalOT + 1;
    } else if (
      element.createdAs === CREATED_AS_TYPE.accidentalLeave
    ) {
      TotalAml = TotalAml + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.WOP) {
      TotalWop = TotalWop + 1;
    } else if (element.createdAs === CREATED_AS_TYPE.fullTime) {
      TotalPresent = TotalPresent + 1;
    } else {
      TotalAbsent = TotalAbsent + 1;
    }
  });

  return {
    TotalHours,
    TotalPresent,
    TotalAbsent,
    TotalWeekOf,
    TotalPl,
    TotalNbl,
    TotalPtl,
    TotalMtl,
    TotalBl,
    TotalCo,
    TotalOh,
    TotalPh,
    TotalOd,
    TotalEo,
    TotalLc,
    TotalHd,
    TotalOT,
    TotalAml,
    TotalWop
  };
};

const renderSheetCreatedAs = (attendanceValue) => {
  if (isEmpty(attendanceValue)) {
    return CREATED_AS_TYPE.absent;
  } else {
    if (
      attendanceValue.occasion !== "-" &&
      attendanceValue.inCreatedAs === CREATED_AS_TYPE.absent &&
      attendanceValue.outCreatedAs === CREATED_AS_TYPE.absent
    ) {
      return CREATED_AS_TYPE.paidHoliday;
    } else if (
      attendanceValue.createdAs === CREATED_AS_TYPE.weeklyOff ||
      (attendanceValue.shiftCode === SHIFT_TYPE.weeklyOff &&
        attendanceValue.inCreatedAs === CREATED_AS_TYPE.absent &&
        attendanceValue.outCreatedAs === CREATED_AS_TYPE.absent)
    ) {
      return SHIFT_TYPE.weeklyOff;
    } else if (
      attendanceValue.shiftCode === SHIFT_TYPE.weeklyOff &&
      attendanceValue.inCreatedAs !== CREATED_AS_TYPE.absent &&
      attendanceValue.outCreatedAs !== CREATED_AS_TYPE.absent
    ) {
      return CREATED_AS_TYPE.WOP;
    } else {
      return renderShift(
        attendanceValue.inCreatedAs,
        attendanceValue.outCreatedAs
      );
    }
  }
};

const createdAsFunction = (attendanceValue) => {
  if (isEmpty(attendanceValue)) {
    return CREATED_AS_TYPE.absent;
  } else if (
    attendanceValue?.inCreatedAs === CREATED_AS_TYPE.absent ||
    attendanceValue?.outCreatedAs === CREATED_AS_TYPE.absent
  ) {
    return CREATED_AS_TYPE.absent;
  } else {
    if (
      !isEmpty(attendanceValue.occasion) &&
      isEmpty(attendanceValue.inCreatedAs) &&
      isEmpty(attendanceValue.outCreatedAs)
    ) {
      return CREATED_AS_TYPE.paidHoliday;
    } else if (
      attendanceValue.shiftCode === SHIFT_TYPE.weeklyOff &&
      isEmpty(attendanceValue.inCreatedAs) &&
      isEmpty(attendanceValue.outCreatedAs)
    ) {
      return SHIFT_TYPE.weeklyOff;
    } else if (
      attendanceValue.inCreatedAs === SHIFT_TYPE.weeklyOff &&
      attendanceValue.outCreatedAs === SHIFT_TYPE.weeklyOff
    ) {
      return SHIFT_TYPE.weeklyOff;
    } else if (
      attendanceValue.shiftCode === SHIFT_TYPE.weeklyOff &&
      !isEmpty(attendanceValue.inCreatedAs) &&
      !isEmpty(attendanceValue.outCreatedAs)
    ) {
      return CREATED_AS_TYPE.WOP;
    } else if (
      !isEmpty(attendanceValue.createdAs) &&
      isEmpty(attendanceValue.inCreatedAs) &&
      isEmpty(attendanceValue.outCreatedAs)
    ) {
      return attendanceValue.createdAs;
    } else {
      return renderShift(
        isEmpty(attendanceValue.inCreatedAs)
          ? "-"
          : attendanceValue.inCreatedAs,
        isEmpty(attendanceValue.outCreatedAs)
          ? "-"
          : attendanceValue.outCreatedAs
      );
    }
  }
};

const totalDynamicPAH = (dailyPointsArray, dataType) => {
  let totalValue = 0;
  dailyPointsArray.map((element) => {
    // TotalHours = TotalHours + timeToSecond(element.duration);
    if (element.createdAs === dataType) {
      totalValue = totalValue + 1;
    }
  });

  return {
    totalValue
  };
};

const monthList = {
  JANUARY: "JANUARY",
  FEBRUARY: "FEBRUARY",
  MARCH: "MARCH",
  APRIL: "APRIL",
  MAY: "MAY",
  JUNE: "JUNE",
  JULY: "JULY",
  AUGUST: "AUGUST",
  SEPTEMBER: "SEPTEMBER",
  OCTOBER: "OCTOBER",
  NOVEMBER: "NOVEMBER",
  DECEMBER: "DECEMBER"
};
const yearList = {
  2024: "2024",
  2025: "2025",
  2026: "2026",
  2027: "2027",
  2028: "2028",
  2029: "2029"
};

export {
  totalCanteen,
  isAdmin,
  csvJSON,
  totalDynamicPAH,
  yearList,
  totalPAH,
  monthList,
  isWeekend,
  renderShift,
  renderDate,
  renderState,
  toastHelper,
  filterQuery,
  isSuperAdmin,
  FilterWorker,
  locationRender,
  secondsToTime,
  tableSkeleton,
  TimeStampIntoDate,
  convertBase64,
  checkLoginType,
  showAttendanceAs,
  getBrowserDetails,
  TimeStampIntoHours,
  renderAccessLocation,
  advancedFilterWorker,
  renderAccessLocation2,
  renderLocationFunction,
  sortDateAscendingOrder,
  uploadImageToCloudinary,
  sortShiftDateAscendingOrder,
  renderReportingMangersFunction,
  uploadMultipleImageToCloudinary,
  sortDailyAttByDateAscendingOrder,
  createdAsFunction,
  renderSheetCreatedAs
};
